import axios from "axios";
import Cookies from "js-cookie";

const api = axios.create({
  baseURL: "https://hmca-api.hezee.co.in/api"
  // baseURL: "http://127.0.0.1:8000/api",
});

api.interceptors.request.use((config) => {
  const token = Cookies.get("authToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (!error.response) {
      alert("⚠️ Network Error: Check your internet or server!");
      return Promise.reject(error);
    }

    const { status, data } = error.response;

    const message = data?.message || "Unexpected error occurred";
    const errorType = data?.error || "UnknownError";

    if (status === 401) {
      Cookies.remove("authToken");

      if (!sessionStorage.getItem("expired_notified")) {
        alert("Session expired. Please sign in again.");
        sessionStorage.setItem("expired_notified", "true");
      }
      window.location.reload();
      return Promise.reject(error);
    }

    if (status === 403) alert("Access denied.");
    else if (status === 404) alert(message);
    else if (status >= 500) alert(`Server error: ${message}`);
    else alert(message);

    return Promise.reject(error);
  }
);

export default api;

export const getPropertyDetails = async (propertyId) => {
  try {
    const response = await api.get(`/property/${propertyId}`);
    return response.data.data;
  } catch (error) {
    console.error("Failed to fetch property:", error);
    throw error;
  }
};
